export default {
  Tips_Common: {
    Changes_Clinic_Settings: '正在修改診所診治設置，是否保存？',
    Cntrols_Successfully: '操作成功',
    Input_Promotion_Name: '請輸入轉介碼名称',
    Input_Promotion_Code: '請輸入轉介碼',
    reset_successfully: '重置成功',
    edit_successfully: '修改成功',
    add_successfully: '新增成功',
    complete_certificate: '請完善證書列表',
    has_confirm_shutdown: '數據發生了修改，確認關閉？',
    enter_account: '請輸入賬號',
    must_account_less: '賬號長度不能少於6',
    must_account_than: '賬號長度不能大於20',
    must_account_fomat:
      '格式為單一或任意組合的字母數字和字符_-@.並且長度為6~20',
    format_error: '輸入格式錯誤',
    enter_id: '請輸入證件號碼',
    must_id_less: '證件號碼長度需大於等於0',
    perfect_source: '請先完善號源',
    file_format_incorrect: '文件格式不正確, 請上傳jpeg、png或pdf格式文件',
    enter_name: '請輸入姓名',
    enter_phone: '請輸入手機號',
    select_birth: '請選擇出生日期',
    select_sex: '請選擇性別',
    select_scheduling: '請選擇是否排班',
    enter_describe: '請輸入描述',
    select_cert_type: '請選擇證書類型',
    enter_certificate_numb: '請輸入證書編號',
    enter_certificate_title: '請輸入證書名稱',
    select_issue_date: '請選擇發證時間',
    upload_attachment: '請上傳附件',
    search_menu: '搜索菜單',
    full_screen: '全屏',
    full_screen_out: '退出全屏',
    content_recovery: '內容區復原',
    content_enlargement: '內容區放大',
    content_full_screen: '內容區全屏',
    deleting_role: '正在刪除角色',
    confirm_deletion: '確認刪除',
    del_successfully: '刪除成功',
    input_bag_time: '請輸入包/次',
    input_g_bag: '請輸入克/包',
    bag_time_need: '包/次不可為0',
    g_bag_need: '克/包不可為0',
    method_need: '請至少選擇一種支付方式',
    postage_need: '請輸入郵費',
    cannot_null: '電子秤設定值不可為空',
    end_equal_start: '電子秤設定結束值必須等於下一階段的開始值',
    config_save_no: '正在修改診所配置，是否保存',
    save_successfully: '保存成功',
    err_network: '網絡錯誤，請稍後重試',
    loading: '加載中',
    discount_example: '80% = 8折',
    denomination_need: '請輸入面額',
    discount_need: '請輸入折扣',
    enter_coupon_name: '請輸入優惠券名稱',
    select_is_coupon: '請選擇是否優惠券',
    select_coupon_type: '請選擇優惠券類型',
    select_is_enable: '請選擇是否啟用',
    enter_amount: '請輸入金額',
    select_scope_use: '請選擇使用範圍',
    denomination_less_amount: '面額必須小於滿減目標金額',
    deleting_project: '正在刪除項目',
    attachment_load: '附件上傳中，請稍後',
    information_backfill: '當前證件號碼存在用戶信息，是否回填',
    cannot_activated: '此藥品平台已停用，需啟用請聯繫平台管理者',
    select_address: '請選擇地址信息',
    tips_address: '詳細地址長度需要在2-120個漢字或字符, 不能包含表情符號',
    use_default: '是否確認設置為默認地址',
    enter_pingyin: '請輸入中文或拼音',
    enter_code: '請輸入編碼',
    enter_price: '請輸入售價',
    enter_min_whole: '請輸入最少單位量',
    enter_max_whole: '請輸入最大單位量',
    complete_order: '是否完結當前訂單',
    order_completed: '訂單已完成',
    cancel_successfully: '取消成功',
    no_record: '暫無簽收記錄',
    no_data: '暫無數據',
    enter_opinion: '請輸入審批意見',
    audit_completed: '審核完成',
    enter_description: '請輸入項目描述',
    cannot_empty: '訂單不可為空',
    submit_successfully: '提交成功',
    clear_order_list: '確認清空訂單列表',
    temporary_successfully: '暫存成功',
    bring_quantity: '一鍵帶入下單數量',
    least_one_drug: '至少需要簽收一樣藥品',
    confirm_receipt: '確認簽收訂單',
    continue_sign: '簽收數量為0，是否繼續簽收',
    sign_successfully: '簽收成功',
    expired_continue_sign: '藥品已過了有效期，是否繼續簽收',
    sign_remaining_all: '是否簽收全部剩下下單數量',
    invalid_barcode: '無效的條形碼',
    not_onpurchase: '藥品不在采購列表中',
    signings_not_exceed: '簽收數量不可多於下單數量',
    whether_backfill: '當前證件號存在用戶信息，是否回填',
    enter_prepaid_name: '請輸入級別名稱',
    select_level: '請選擇級別',
    enter_discount: '請輸入級別優惠',
    enter_discount_zero: '級別優惠不能為0',
    enter_threshold: '請輸入起步金額',
    enter_threshold_zero: '起步金額不能為0',
    deleting_card: '正在刪除儲值級別',
    level_exists: '級別已存在',
    starting_exists: '起步金額已存在',
    confirm_report: '確定上報',
    cntrols_successfully: '操作成功',
    no_standard: '沒有配置標準',
    sign_first: '請先簽名',
    report_first: '上報成功',
    be_un_inequality: '兩次輸入的新密碼不一致',
    confirm_delete_group:
      '刪除當前組會將連帶關聯的收費規則及收費項目一起刪除，是否確認刪除',
    confirm_delete_rule:
      '刪除當前規則會將連帶關聯的收費項目一起刪除，是否確認刪除',
    set_default: '是否確認設置為默認收費類別',
    use_price: '使用藥物的售價收費',
    use_cost: '使用藥物的成本收費',
    use_ticket: '使用套票的售價收費',
    use_fee: '使用醫師的診金收費',
    edit_print: '正在修改打印配置，是否保存',
    pay_modify: '預設開啟後收費信息不可編輯',
    enter: '請輸入',
    sku_exists: '藥品已經存在',
    complete_dosage: '請完善藥品用量',
    acupoint_exists: '穴位已經存在',
    drug_detail: '詳情(使用飲片用量)',
    confirm_syncing: '是否確定同步藥品信息至當前產品',
    empty_no: '不可為空',
    prefix_repeat: '字頭不可重複',
    un_down_data: '當前沒有可下載的數據',
    complete_rule: '請完善規則列表',
    input_name_code: '支持產品名稱、編碼搜索',
    input_name_code_phone: '支持客戶編號、證件號碼、姓名、電話搜索',
    input_code_name_phone: '支持證件號碼、姓名、電話搜索',
    input_name_en: '請輸入中文姓名或者英文姓名',
    birthday_out: '出生日期不可超過今天',
    electronic_empty: '電子秤設定值不可為空',
    start_next: '電子秤設定結束值必須等於下一階段的開始值',
    input_type: '請輸入類別',
    source_get_tips1: '* 將生成新號源，請確定是否覆蓋舊號源。',
    source_get_tips2: '覆蓋（從第二天開始生成）',
    source_get_tips3: '不覆蓋（從最後號源的第二天開始生成）',
    no_chinese_id: '證件號碼不可輸入中文',
    complete_certificate_list: '請完善證書列表！',
    openTime_closeTime_no: '營業時間設定值不可為空！',
    openTime_closeTime_before: '營業時間的結束時間必須在開始時間之後！',
    openTime_pre_closeTime_after:
      '營業時間的開始時間必須在上一階段的結束時間之後！',
    days_cannot_empty: '天數不可為空！',
    frequency_cannot_empty: '每天/次不可為空！',
    confirm_delete: '是否確認刪除？',
    QueRen_BaoCun: '確認保存？',
    ChuFang_ChaoGuo: '處方數量超過兩條，是否繼續套用？',
  },
}
